enum Portal {
  CompanyPortal = 'company_portal',
  Experience = 'experience',
}

export default Portal;
